import type { Preferences } from './contracts';

const key = 'chaosverse.preferences.v1';
export const defaults: Preferences = {
  sound: false, volume: 0.6, quality: 'auto', cinematic: false, directorsCut: false,
};

export function readPreferences(): Preferences {
  try {
    const saved = JSON.parse(localStorage.getItem(key) ?? '{}');
    return {
      sound: typeof saved.sound === 'boolean' ? saved.sound : defaults.sound,
      volume: typeof saved.volume === 'number' && Number.isFinite(saved.volume)
        ? Math.min(1, Math.max(0, saved.volume)) : defaults.volume,
      quality: ['auto', 'cinematic', 'lightweight'].includes(saved.quality) ? saved.quality : defaults.quality,
      cinematic: typeof saved.cinematic === 'boolean' ? saved.cinematic : defaults.cinematic,
      directorsCut: typeof saved.directorsCut === 'boolean' ? saved.directorsCut : defaults.directorsCut,
    };
  } catch { return { ...defaults }; }
}

export function savePreferences(preferences: Preferences): void {
  try { localStorage.setItem(key, JSON.stringify(preferences)); } catch { /* Private storage may be unavailable. */ }
}
